import { type ComponentType, createElement } from 'react';

import type { LayoutProps } from './types';

import * as ClientPages from '@/pages/client/lazy';

import { BlacklistedScreen } from './BlacklistedScreen';
import { Footer } from './Footer';
import { Header } from './Header';

const AppLayoutClient = (props: LayoutProps) => {
  const {
    children,
    footer_logo_url,
    logo_url,
    client_name,
    log_out_props,
    layout,
    layout_data,
    home_page_url,
    auth_url,
    my_booking_url,
    booking_types_url,
    booking_class_url,
    booking_spot_event_url,
    booking_url,
    online_booking_url,
    my_reservations_url,
    company_base_settings,
    my_subscription_url,
    tickets_url,
    cards_url,
    subscription_cards_url,
    client_subscription_url,
    certificates_url,
    client_certificates_url,
    subscriptions_url,
    online_certificates_url,
    blacklisted,
    blacklist_message,
    payment_maintenance_warning,
  } = props;

  if (blacklisted) {
    return (
      <BlacklistedScreen
        message={blacklist_message}
        logOutProps={log_out_props}
      />
    );
  }

  const headerNavigation = {
    logo_url,
    home_page_url,
    auth_url,
    my_booking_url,
    booking_types_url,
    booking_class_url,
    booking_spot_event_url,
    booking_url,
    online_booking_url,
    my_reservations_url,
    my_subscription_url,
    tickets_url,
    cards_url,
    subscription_cards_url,
    client_subscription_url,
    certificates_url,
    client_certificates_url,
    subscriptions_url,
    online_certificates_url,
  };

  const clientData = {
    client_name,
    log_out_props,
  };

  const LayoutComponent = layout
    ? ((ClientPages as unknown as Record<string, ComponentType<unknown>>)[
        layout
      ] as ComponentType<{ layout_data: unknown; children: unknown }>)
    : null;

  return (
    <div className="bg-background flex min-h-screen flex-col">
      <Header
        navigation={headerNavigation}
        clientData={clientData}
        payment_maintenance_warning={payment_maintenance_warning}
      />
      <main className="mx-auto flex w-full flex-1 px-4 py-8">
        <div className="flex flex-1 flex-col">
          {LayoutComponent &&
            createElement(LayoutComponent, {
              layout_data,
              children,
            })}
          {!LayoutComponent && children}
        </div>
      </main>
      <Footer
        footer_logo_url={footer_logo_url}
        company_base_settings={company_base_settings}
      />
    </div>
  );
};

export { AppLayoutClient, Footer, Header };
